<mat-progress-bar mode="indeterminate" id="apiLoad" class="hidden"></mat-progress-bar>
<router-outlet></router-outlet>
<confirm-dialog-modal></confirm-dialog-modal>